import { v4 as uuidv4 } from 'uuid';

export const SALAD_SHOOTER_STREAM_ID_SESSION_KEY = 'hr.salad-shooter.stream-id';

export function getStreamId() {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(SALAD_SHOOTER_STREAM_ID_SESSION_KEY);
  }

  return null;
}

function generateStreamId() {
  return 'stream_id_' + uuidv4();
}

function initializeStreamId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  let streamId = sessionStorage.getItem(SALAD_SHOOTER_STREAM_ID_SESSION_KEY);

  if (streamId === null) {
    streamId = generateStreamId();
    sessionStorage.setItem(SALAD_SHOOTER_STREAM_ID_SESSION_KEY, streamId);
  }

  return streamId;
}

try {
  initializeStreamId();
} catch {
  // No-op: avoid crashing on import
}
